<highcharts-chart
  class="m-stacked-column-chart"
  [Highcharts]="Highcharts"
  [options]="chartOptions"></highcharts-chart>
